import { render, staticRenderFns } from "./rmBtodAll.vue?vue&type=template&id=68f998e2"
import script from "./rmBtodAll.vue?vue&type=script&lang=js"
export * from "./rmBtodAll.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports